/**
 * MicOrb — embeds the WG signature MicButton (vendored from
 * apps/wunderguide-web/src/common/MicButton.tsx) and drives every prop
 * (mic/bot levels, isBotWorking, hasRemote, listening/connecting) from
 * VoiceContext, which wraps the canonical `useEmbedAudioChat` hook.
 *
 * State lives at App level so the LiveKit room survives view switches.
 */
import React from 'react';
import MicButton from './MicButton';
import { useVoice } from '../context/VoiceContext';

interface Props {
  /** Wrapper size when idle (px). */
  idleSize?: number;
  /** Wrapper size when active (connecting/listening). */
  activeSize?: number;
}

const MicOrb: React.FC<Props> = ({ idleSize = 78, activeSize = 160 }) => {
  const voice = useVoice();
  const active = voice.isListening || voice.isConnecting;

  return (
    <MicButton
      isListening={voice.isListening}
      isConnecting={voice.isConnecting}
      hasRemoteParticipant={voice.hasRemoteParticipant}
      micAudioLevel={voice.micAudioLevel}
      botAudioLevel={voice.botAudioLevel}
      isBotWorking={voice.isBotWorking}
      onPress={() => {
        // Fire-and-forget — toggleListening internally awaits.
        voice.toggleListening();
      }}
      wrapperSize={active ? activeSize : idleSize}
    />
  );
};

export default MicOrb;
